<div>
  <app-user-info
    [userInfo]="tableRowData[tableCellAttribute.key]"
    [srtIndex]="rowIndex + '-' + cellIndex"
    [hasTableSizeLimit]="true"
    [redirectToLoginIfNoSession]="redirectToLoginIfNoSession"
  ></app-user-info>
</div>
